module.exports = __webpack_public_path__ + "img/weiguan.959bacfe.gif";